module.exports = __webpack_public_path__ + "static/media/eliberty2.ae79be8a.jpg";